import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import AuthorAnswerNewsfeedItem from "./author_answer/author_answer_newsfeed_item";
import ReaderAnswerNewsfeedItem from "./reader_answer/reader_answer_newsfeed_item";
import _ from "lodash";

/*
  CommunityQuestions are used for both the Reader Q&A and Ask the Author products.
  The object's `category` attribute denotes whether it is a reader or author
  question. These constant values are originally defined in community_question.rb,
  see file for further explanation.
*/
const CommunityQuestionCategories = {
  AUTHOR_CATEGORY: 1,
  READER_CATEGORY: 2,
};

export default GrComponentFactory.createClass({
  displayName: "CommunityAnswerNewsfeedItem",

  statics: {
    CommunityQuestionCategories,
  },

  propTypes: {
    resource: React.PropTypes.shape(GrPropTypes.communityAnswer()),
  },

  render() {
    switch (this.props.resource.communityQuestion.category) {
      case CommunityQuestionCategories.AUTHOR_CATEGORY:
        return <AuthorAnswerNewsfeedItem {...this.props} />;
      case CommunityQuestionCategories.READER_CATEGORY:
        return <ReaderAnswerNewsfeedItem {...this.props} />;
      default:
        throw new Error("Unexpected category passed to CommunityAnswer. " +
                         `Received ${this.props.resource.communityQuestion.category}. ` +
                         `Expected one of ${_.values(CommunityQuestionCategories)}`);
    }
  },
});
